import React from "react";
import "./file-toolbar.css";

function FileToolbar({
	newFolderOptions,
	uploadOptions,
	cutOptions,
	copyOptions,
	pasteOptions,
	duplicateOptions,
	deleteOptions,
	renameOptions,
	downloadOptions,
	refreshOptions,
	infoOptions,
	shareOptions,
	isSharedFolder,
	viewModeOptions
}) {
	const { perms } = hp.store;

	const toolbarItems = {
		leftSide: [
			{
				options: {
					show: perms.canEdit && newFolderOptions,
					disabled: (newFolderOptions?.disabled || isSharedFolder) ?? false,
					icon: newFolderOptions?.icon ?? "la la-plus",
					text: newFolderOptions?.text ?? "Nova Pasta",
					onClick: newFolderOptions?.onItemClicked,
				},
			},
			{
				options: {
					show: perms.canEdit && uploadOptions,
					disabled: (uploadOptions?.disabled || isSharedFolder) ?? false,
					icon: uploadOptions?.icon ?? "la la-upload",
					text: uploadOptions?.text ?? "Upload",
					onClick: uploadOptions?.onItemClicked
				},
			},
			{
				options: {
					show: perms.canEdit && cutOptions ,
					disabled: (cutOptions?.disabled || isSharedFolder) ?? false,
					icon: cutOptions?.icon ?? "la la-cut",
					title: cutOptions?.text ?? "Cortar",
					onClick: cutOptions?.onItemClicked
				},
			},
			{
				options: {
					show: perms.canEdit && copyOptions,
					disabled: copyOptions?.disabled ?? false,
					icon: copyOptions?.icon ?? "la la-copy",
					title: copyOptions?.text ?? "Copiar",
					onClick: copyOptions?.onItemClicked
				},
			},
			{
				options: {
					show: perms.canEdit && pasteOptions,
					disabled: (pasteOptions?.disabled || isSharedFolder) ?? false,
					icon: pasteOptions?.icon ?? "la la-paste",
					title: pasteOptions?.text ?? "Colar",
					onClick: pasteOptions?.onItemClicked
				},
			},
			{
				options: {
					show: perms.canEdit && duplicateOptions,
					disabled: (duplicateOptions?.disabled || isSharedFolder) ?? false,
					icon: duplicateOptions?.icon ?? "la la-clone",
					text: duplicateOptions?.text ?? "Duplicar",
					onClick: duplicateOptions?.onItemClicked
				},
			},
			{
				options: {
					show: perms.canEdit && deleteOptions,
					disabled: (deleteOptions?.disabled || isSharedFolder) ?? false,
					icon: deleteOptions?.icon ?? "la la-trash",
					text: deleteOptions?.text ?? "Apagar",
					onClick: deleteOptions?.onItemClicked
				},
			},
			{
				options: {
					show: perms.canEdit && renameOptions,
					disabled: (renameOptions?.disabled || isSharedFolder) ?? false,
					icon: renameOptions?.icon ?? "la la-edit",
					text: renameOptions?.text ?? "Renomear",
					onClick: renameOptions?.onItemClicked
				},
			},
			{
				options: {
					show: perms.canRead && downloadOptions,
					disabled: downloadOptions?.disabled ?? false,
					icon: downloadOptions?.icon ?? "la la-download",
					text: downloadOptions?.text ?? "Download",
					onClick: downloadOptions?.onItemClicked
				},
			},
			{
				options: {
					show: refreshOptions ?? false,
					disabled: refreshOptions?.disabled ?? false,
					icon: refreshOptions?.icon ?? "la la-sync",
					title: refreshOptions?.text ?? "Atualizar",
					onClick: refreshOptions?.onItemClicked
				},
			},
		],
		rightSide: [
			{
				options: {
					show: perms.canShare && shareOptions,
					disabled: (shareOptions?.disabled || isSharedFolder) ?? false,
					icon: shareOptions?.icon ?? "la la-share-square",
					title: shareOptions?.text ?? "Partilhar",
					onClick: shareOptions?.onItemClicked
				},
			},
			{
				options: {
					show: infoOptions ?? false,
					disabled: infoOptions?.disabled ?? false,
					icon: infoOptions?.icon ?? "la la-info-circle",
					title: infoOptions?.text ?? "Info",
					onClick: infoOptions?.onItemClicked
				},
			},
			{
				options: {
					show: viewModeOptions ?? false,
					disabled: viewModeOptions?.disabled ?? false,
					icon: viewModeOptions?.icon ?? "la la-list",
					title: viewModeOptions?.text,
					onClick: viewModeOptions?.onItemClicked
				},
			}
		],
	};

	return (
		<div className="file-toolbar">
			<div className="file-toolbar-left">
				{toolbarItems.leftSide.map(
					(item, index) =>
						item.options?.show ? (
							<button key={`leftSide-${index}`} onClick={item.options.onClick} disabled={item.options.disabled} title={item.options.title || item.options.text}>
								<em className={ `file-toolbar-icon ${item.options.icon}`}></em>
								{item.options.text && <span className="file-toolbar-info">{item.options.text}</span>}
							</button>
						) : null
				)}
			</div>
			<div className="file-toolbar-right">
				{toolbarItems.rightSide.map(
					(item, index) =>
						item.options?.show ? (
							<button key={`rightSide-${index}`} onClick={item.options.onClick} disabled={item.options.disabled} title={item.options.title || item.options.text}>
								<em className={ `file-toolbar-icon ${item.options.icon}`}></em>
								{item.options.text && <span className="file-toolbar-info">{item.options.text}</span>}
							</button>
						) : null
				)}
			</div>
		</div>
	);
}

export default FileToolbar;
